import React from 'react';
import { motion } from 'framer-motion';
import { LuLinkedin as Linkedin } from 'react-icons/lu';
import { textContainerVariants, textVariants } from '../../lib/animations';

const FounderNote = () => {
  return (
    <section className="py-16 md:py-24 bg-black">
      <div className="container mx-auto px-4 md:px-6">
        <motion.p
          className="text-center text-sm uppercase tracking-wide text-white font-semibold mb-8 md:mb-12"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
        >
          A Note from Our Founder
        </motion.p>

        <motion.div
          className="max-w-6xl mx-auto bg-white/5 border border-white/10 rounded-3xl overflow-hidden backdrop-blur-sm group relative cursor-pointer"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          whileHover={{ y: -8 }}
        >
          <div className="grid lg:grid-cols-2 gap-0">
            <motion.div
              className="relative h-[400px] sm:h-[500px] lg:h-auto overflow-hidden"
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.4 }}
            >
              <img
                src="https://cdn.prod.website-files.com/62714322a659c56310ea38fe/6281f2cccf36021cc98322e6_1Z9A1746.jpg"
                alt="Rohan Mishra"
                className="w-full h-full object-cover grayscale"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent opacity-80" />
              <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

              <div className="absolute bottom-6 md:bottom-8 left-6 md:left-8 z-20">
                <div className="inline-flex items-center px-3 py-1 bg-white/10 backdrop-blur-md rounded-lg border border-white/10 mb-2 md:mb-3">
                  <span className="text-xs font-bold text-white uppercase tracking-wider">Founder & Creative Director</span>
                </div>
                <h3 className="text-xl md:text-2xl font-bold text-white">Rohan Mishra</h3>
              </div>
            </motion.div>

            <div className="p-6 sm:p-8 md:p-12 flex flex-col justify-center">
              <motion.h2
                className="text-2xl sm:text-2xl md:text-3xl font-bold text-white mb-4 md:mb-6"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
              >
                Design That Drives Business, Not Just Pixels
              </motion.h2>

              <motion.div
                className="space-y-3 md:space-y-4 text-sm sm:text-base text-neutral-300 leading-relaxed mb-6 md:mb-8"
                variants={textContainerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
              >
                <motion.p variants={textVariants}>
                  I founded Arabica Design Studio with a simple belief: design should directly impact business outcomes. After 10+ years as a content strategist and working with founders across India, I saw firsthand how great design separated successful startups from the rest.
                </motion.p>
                <motion.p variants={textVariants}>
                  At Arabica, we don't just create beautiful interfaces - we embed with your team as dedicated design partners. Our framework is built for startup speed: weekly deliverables, data-driven decisions, and conversion-focused design. Whether you're in E-commerce, Fintech, or AI, we understand your unique challenges and design solutions that drive revenue.
                </motion.p>
                <motion.p variants={textVariants}>
                  Let's build something exceptional together.
                </motion.p>
              </motion.div>

              <motion.div
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.4 }}
              >
                <div className="mb-3 md:mb-4">
                  <motion.div
                    className="w-32 md:w-48 h-1 bg-white rounded-full"
                    initial={{ width: 0 }}
                    whileInView={{ width: '100%' }}
                    transition={{ duration: 1.5, ease: "easeInOut", delay: 0.5 }}
                  />
                </div>
                <p className="font-bold text-white text-base md:text-lg">Rohan Mishra</p>
                <p className="text-neutral-400 mb-3 md:mb-4 text-xs md:text-sm">Founder & Creative Director</p>
                <a
                  href="https://www.linkedin.com/in/iamrohanmishra/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-white hover:text-neutral-300 transition-colors text-xs md:text-sm"
                >
                  <Linkedin className="w-4 h-4" />
                  Connect on LinkedIn
                </a>
              </motion.div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default FounderNote;